export default __webpack_public_path__ + "static/media/sunset.7cfe8e1e.jpg";